import React, { useState } from 'react';
import BreakCreationForm from './BreakInterface/BreakCreationForm';
import RazzCreationForm from './RazzInterface/RazzCreationForm';

const RazzBreakPanel = () => {
  const [section, setSection] = useState('break'); // Initial section is 'break'
  const [showCreateForm, setShowCreateForm] = useState(false); // State to control the display of create forms

  const handleSectionChange = (newSection) => {
    setSection(newSection);
    setShowCreateForm(false); // Reset the state when changing sections
  };

  const handleCreateBreak = (breakData) => {
    console.log('Creating Break:', breakData);
    // Implement logic to handle Break creation
    setShowCreateForm(false); // Hide the form after creation
  };

  const handleCreateRazz = (razzData) => {
    console.log('Creating Razz:', razzData);
    // Implement logic to handle Razz creation
    setShowCreateForm(false); // Hide the form after creation
  };

  const handleAddToWatchList = (listingId) => {
    // Implement logic to add the listing to the watchlist
    console.log(`Added listing ${listingId} to watchlist`);
  };

  const handleViewListing = (listingId) => {
    // Implement logic to view the details of the listing
    console.log(`Viewing details of listing ${listingId}`);
  };

  const sectionStyle = {
    padding: '20px',
    border: '1px solid #ccc',
    marginBottom: '20px',
  };

  const productStyle = {
    marginBottom: '10px',
    padding: '10px',
    border: '1px solid #ddd',
    borderRadius: '5px',
    backgroundColor: '#f9f9f9',
  };

  return (
    <div>
      <div>
        <label>
          <input
            type="radio"
            value="break"
            checked={section === 'break'}
            onChange={() => handleSectionChange('break')}
          />
          Break
        </label>
        <label>
          <input
            type="radio"
            value="razz"
            checked={section === 'razz'}
            onChange={() => handleSectionChange('razz')}
          />
          Razz
        </label>
      </div>
      {section === 'break' ? (
        <div style={sectionStyle}>
          <button onClick={() => setShowCreateForm(true)}>Create Break for breaker</button>
          {showCreateForm && <BreakCreationForm handleCreateBreak={handleCreateBreak} />}

          <h2>Break Section</h2>
          {/* Implement your grid for buying products and filters */}
          {/* Example Product */}
          <div style={productStyle}>
            Product Name: Product 1
            <button onClick={() => handleAddToWatchList(1)}>Add to Watchlist</button>
            <button onClick={() => handleViewListing(1)}>View Listing</button>
          </div>
          {/* Example Product */}
          <div style={productStyle}>
            Product Name: Product 2
            <button onClick={() => handleAddToWatchList(2)}>Add to Watchlist</button>
            <button onClick={() => handleViewListing(2)}>View Listing</button>
          </div>
          {/* Add more products as needed */}
        </div>
      ) : (
        <div style={sectionStyle}>
          <button onClick={() => setShowCreateForm(true)}>Create Razz for razzer 3rd party</button>
          {showCreateForm && <RazzCreationForm handleCreateRazz={handleCreateRazz} />}

          <h2>Razz Section</h2>
          {/* Implement your listing display for the Razz section */}
          {/* Example Listing */}
          <div style={productStyle}>
            Listing Name: Listing 1
            <button onClick={() => handleAddToWatchList(1)}>Add to Watchlist</button>
            <button onClick={() => handleViewListing(1)}>View Listing</button>
          </div>
          {/* Example Listing */}
          <div style={productStyle}>
            Listing Name: Listing 2
            <button onClick={() => handleAddToWatchList(2)}>Add to Watchlist</button>
            <button onClick={() => handleViewListing(2)}>View Listing</button>
          </div>
          {/* Add more listings as needed */}
        </div>
      )}
    </div>
  );
};

export default RazzBreakPanel;
